import {useMutation} from '@tanstack/react-query';
import {API, FieldsErrorResponse} from '@chekin/api';
import {LivenessDetection} from '@chekin/core';

type Props = {
  onSuccess?: (data: LivenessDetection) => void;
  onError?: (error: FieldsErrorResponse) => void;
  onSettled?: () => void;
};
function useMutateLivenessDetection({onSuccess, onError, onSettled}: Props) {
  return useMutation<LivenessDetection, FieldsErrorResponse, LivenessDetection>({
    mutationFn: variables => API.guest.livenessDetection(variables),
    onSuccess,
    onError,
    onSettled,
  });
}

export {useMutateLivenessDetection};
